export default {"src":"/_next/static/media/share.595a7017.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};